module.exports = __webpack_public_path__ + "img/carrot_expand.d092083a.svg";